/* global gdAlertify */
import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../../config/axiosConfig";

const ModalRecordatoriosPaciente = ({ isOpen, onClose, pacienteId, pacienteNombre }) => {
    const [recordatorio, setRecordatorio] = useState("");
    const [recordatorioValorTurno, setRecordatorioValorTurno] = useState("");
    const [recordatorioMovilizacion, setRecordatorioMovilizacion] = useState("");
    const [recordatorioColacion, setRecordatorioColacion] = useState("");
    const [loading, setLoading] = useState(false);

    const limpiarCampos = useCallback(() => {
        setRecordatorio("");
        setRecordatorioValorTurno("");
        setRecordatorioMovilizacion("");
        setRecordatorioColacion("");
    }, []);

    const fetchRecordatorio = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/paciente/${pacienteId}/recordatorio`);
            const data = response.data?.data;
            if (data) {
                setRecordatorio(data.observacion || "");
                setRecordatorioValorTurno(data.recordatorio_valor_turno || "");
                setRecordatorioMovilizacion(data.recordatorio_movilizacion || "");
                setRecordatorioColacion(data.recordatorio_colacion || "");
            } else {
                limpiarCampos();
            }
        } catch (error) {
            console.error("Error al cargar recordatorio:", error);
            limpiarCampos();
        } finally {
            setLoading(false);
        }
    }, [limpiarCampos, pacienteId]);

    useEffect(() => {
        if (isOpen && pacienteId) {
            fetchRecordatorio();
        }
    }, [fetchRecordatorio, isOpen, pacienteId]);

    const handleGuardar = async () => {
        try {
            gdAlertify.showLoader();
            await axiosInstance.post("/paciente/recordatorio/guardar", {
                pacienteId,
                observacion: recordatorio,
                recordatorio_valor_turno: recordatorioValorTurno,
                recordatorio_movilizacion: recordatorioMovilizacion,
                recordatorio_colacion: recordatorioColacion,
            });
            gdAlertify.hideLoader();
            gdAlertify.notify("Recordatorio actualizado.", "success");
            onClose();
        } catch (error) {
            gdAlertify.hideLoader();
            console.error("Error al guardar recordatorio:", error);
            gdAlertify.notify("Error al guardar el recordatorio.", "error");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Recordatorios - {pacienteNombre}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {loading ? (
                            <div className="text-center py-3">Cargando...</div>
                        ) : (
                            <>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">Recordatorio general</label>
                                    <textarea
                                        className="form-control"
                                        rows="5"
                                        placeholder="Escribe aqui las notas o recordatorios para este paciente..."
                                        value={recordatorio}
                                        onChange={(e) => setRecordatorio(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Valor turno</label>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            placeholder="Nota visible junto al valor turno..."
                                            value={recordatorioValorTurno}
                                            onChange={(e) => setRecordatorioValorTurno(e.target.value)}
                                        ></textarea>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Movilizacion</label>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            placeholder="Nota visible junto a movilizacion..."
                                            value={recordatorioMovilizacion}
                                            onChange={(e) => setRecordatorioMovilizacion(e.target.value)}
                                        ></textarea>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Colacion</label>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            placeholder="Nota visible junto a colacion..."
                                            value={recordatorioColacion}
                                            onChange={(e) => setRecordatorioColacion(e.target.value)}
                                        ></textarea>
                                    </div>
                                </div>
                                <small className="text-muted">
                                    Los campos de valores solo muestran notas en el calendario; no modifican montos.
                                </small>
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleGuardar}>
                            <i className="bi bi-save me-2"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalRecordatoriosPaciente;
